module.exports = __webpack_public_path__ + "static/media/calendar-waiting-room.a895c271.svg";